import { Strings } from './Strings';

export const getEnGbStrings = () : Strings => ({
  SESSION_EXPIRED: 'Session expired!',
  BOOLEAN_ATTRIBUTE_YES: 'Yes',
  BOOLEAN_ATTRIBUTE_NO: 'No',
  PAGE_NOT_FOUND: 'Page not found...',
  COLLECTIONS_HEADER_LABEL: 'Collections',
  SEARCH_HEADER_LABEL: 'Search',
  INFORMATION_SLIDER_BUTTON: '+ INFORMATION',
  NEXT_SLIDER_SPAN: 'Next',
  PREVIOUS_SLIDER_SPAN: 'Previous',
  SPOTLIGHT_OBJECTS_LABEL: 'Step into the perfect fit with our made-to-measure boots, tailored just for you',
  MENU_FOOTER_LABEL: 'Menu',
  FILTERS_LABEL: 'Filters',
  VARIANTS_OBJECT_LABEL: 'Variants',
  ADD_TO_CART_OBJECT_LABEL: 'Add to cart',
  PRODUCT_LIST_ORDER_LABEL: 'PRODUCT LIST',
  ORDER_TOTAL_LABEL: 'Order total',
  CHECKOUT_ORDER_BUTTON: 'CONTINUE TO CHECKOUT',
  PREVIEW_ORDER_BUTTON: 'Order Preview',
  VARIANT_ORDER_ITEM_LABEL: 'Variant',
  QUANTITY_ORDER_ITEM_LABEL: 'Quantity',
  PRODUCT_ADDED_TOAST_LABEL: 'Product Added!',
  CHECKOUT_ORDER_TOAST_LABEL: 'Request Sent!',
  COMPONENTS_OBJECT_LABEL: 'Components',
  ORDER_DETAIL_TITLE_LABEL: 'Order detail',
  ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL: 'Custom attributes',
  SUBMIT_LABEL: 'Submit',
  ADD_TO_CART_LABEL: 'Add item to cart',
  CUSTOMIZED_VARIANT: 'Customized',
  PRODUCTLIST: 'Product List',
  PRODUCTLISTDOCLABEL_ITEMNAME: 'Item Name',
  PRODUCTLISTDOCLABEL_VARIATION: 'Variation',
  PRODUCTLISTDOCLABEL_COLLECTION: 'Collection',
  PRODUCTLISTDOCLABEL_COMPOSITION: 'Composition',
  PRODUCTLISTDOCLABEL_QUANTITY: 'Qty.',
  NAVIGATE_BACK: 'Go Back',
  REMOVE: 'Remove',
  CLEAR_CART: 'Clear cart',
  RESULTS_FOR: 'results for',
  NO_CONTENT_TEXT: 'Image not available',
  STANDARD: 'Standard',
  PARTS: 'Parts',
  CUSTOMIZATIONS: 'Customizations',
  PRICE: 'Price',
  TOTAL: 'Total',
  QUANTITY: 'Quantity',
  MEASURES: 'Measures',
  CUSTOM_ATTRIBUTES: 'Custom Attributes',
  LOGIN_SUCCESSFUL: 'Login Successful',
  LOGIN_CREDENTIALS_NOT_VALID: 'Credentials not valid',
  LOGIN_UNKNOWN_ERROR: 'Unknown Error',
  LOGIN_RECOVER_PASSWORD: 'Recover Password',
  LOGIN_CHANGE_PASSWORD: 'Change password',
  LOGIN_USERNAME: 'Username',
  LOGIN_PASSWORD: 'Password',
  LOGIN_OLD_PASSWORD: 'Old password',
  LOGIN_NEW_PASSWORD: 'New password',
  LOGIN_NEW_PASSWORD_REPEAT: 'Repeat new password',
  LOGIN_ACTION_LOGIN: 'Login',
  RECOVER_PASSWORD_MESSAGE: 'A new password has been send to your email.',
  CHANGE_PASSWORD_SUCCESSFUL_MESSAGE: 'Password changed was successful.',
  CHANGE_PASSWORD_ERROR_MESSAGE: 'There was an error trying to change password.',
  CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE: 'The new password must match the new password repear.',
  GO_BACK_ACTION: 'Back',
  CONFIRM_ACTION: 'Confirm',
  SIGN_OUT_ACTION: 'Sign Out',
  OK_ACTION: 'Ok',
  CANCEL_ACTION: 'Cancel',
  RETRY_ACTION: 'Retry',
  RESEND_ACTION: 'Resend',
  ERROR_LABEL: 'Error',
  SUCCESS_LABEL: 'Success',
  ORDER_ERROR_MESSAGE: 'There was an error trying to submit the order.',
  ORDER_SUCCESS_MESSAGE: 'Order submition was successful.',
  DEMO_ORDER_ERROR_MESSAGE: 'Order process in demo mode completed successfully..',
  DEMO_ORDER_SUCCESS_MESSAGE: 'Order process in demo mode completed successfully.',
  VALIDATION_POP_UP_TITLE: 'Email Validation',
  VALIDATION_POP_UP_MESSAGE: 'Please insert the code sent to your email:',
  VALIDATION_POP_UP_ERROR: 'Code doesn\'t match',
  DEMO_WARNING: 'For demonstration purposes only!',
  REPORT_ORDER_INFO_TITLE: 'Order data',
  REPORT_TITLE_DESCRIPTION: 'Description',
  REPORT_TITLE_VALUE: 'Value',
  REPORT_TITLE_QUANTITY: 'Quant.',
  REPORT_TITLE_PRICE: 'Price',
  REPORT_TITLE_SCREENSHOT: 'Screenshot',
  REPORT_TITLE_KEY: 'Name',
});
